import { render, staticRenderFns } from "./pubIndexCIIC.vue?vue&type=template&id=45c8fda8&scoped=true&"
import script from "./pubIndexCIIC.vue?vue&type=script&lang=js&"
export * from "./pubIndexCIIC.vue?vue&type=script&lang=js&"
import style0 from "./pubIndexCIIC.vue?vue&type=style&index=0&id=45c8fda8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c8fda8",
  null
  
)

export default component.exports